import { render, staticRenderFns } from "./CreditorListStatementDetail.vue?vue&type=template&id=360c600b&scoped=true"
import script from "./CreditorListStatementDetail.vue?vue&type=script&lang=js"
export * from "./CreditorListStatementDetail.vue?vue&type=script&lang=js"
import style0 from "./CreditorListStatementDetail.vue?vue&type=style&index=0&id=360c600b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c600b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360c600b')) {
      api.createRecord('360c600b', component.options)
    } else {
      api.reload('360c600b', component.options)
    }
    module.hot.accept("./CreditorListStatementDetail.vue?vue&type=template&id=360c600b&scoped=true", function () {
      api.rerender('360c600b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/creditorlist/CreditorListStatementDetail.vue"
export default component.exports